import type { InvoiceAssignmentInput, InvoiceBreakdownPreview } from "@/api/accounting.tsx"

/**
 * The invoice picks a breakdown was built from, in the shape the prepare request takes:
 * one entry per invoice line the server matched to an invoice.
 */
export function breakdown_picks(breakdown: InvoiceBreakdownPreview): InvoiceAssignmentInput[] {
  const picks: InvoiceAssignmentInput[] = []
  for (const line of breakdown.invoices) {
    if (!line.accounting_invoice_id) {
      continue
    }
    for (const deduction_id of line.line_deduction_ids) {
      picks.push({ deduction_id, accounting_invoice_id: line.accounting_invoice_id })
    }
  }
  return picks
}

/**
 * Whether the page's picks differ from the ones the breakdown was built on, so it must be
 * fetched again before it is shown as the plan. A line left unassigned on the page counts as a
 * difference when the server had matched it, and vice versa.
 */
export function breakdown_is_stale(breakdown: InvoiceBreakdownPreview, assignments: Record<string, string>): boolean {
  const built: Record<string, string> = {}
  for (const pick of breakdown_picks(breakdown)) {
    built[pick.deduction_id] = pick.accounting_invoice_id
  }
  const page_keys = Object.keys(assignments)
  if (page_keys.length !== Object.keys(built).length) {
    return true
  }
  return page_keys.some((deduction_id: string) => built[deduction_id] !== assignments[deduction_id])
}

/** The page's picks as the prepare request takes them. */
export function picks_from_assignments(assignments: Record<string, string>): InvoiceAssignmentInput[] {
  return Object.entries(assignments).map(([deduction_id, accounting_invoice_id]: [string, string]) => ({
    deduction_id,
    accounting_invoice_id,
  }))
}
